import { Input, Table } from "melco-ui";
import { usePlatformSelection } from "../../hooks/hoops/usePlatformSelection";
import { ControlcenterMelcoControlCenterModelsPlatform, ControlcenterMelcoModelsHoop, ControlcenterMelcoModelsSupplierProduct } from "melco-shared-logic";
import { useMemo } from "react";
import { useTranslation } from "react-i18next";

type Props = {
    platformData: ControlcenterMelcoControlCenterModelsPlatform[];
    allMachinesData: ControlcenterMelcoModelsSupplierProduct[];
    hoop: ControlcenterMelcoModelsHoop;
};


export const HoopPlatformList: React.FC<Props> = ({ platformData }) => {
    const { platforms, addPlatforms, removePlatforms, updateSfArea } = usePlatformSelection();
    const { t } = useTranslation()
    //   const selectedRowKeys = platforms.map((p) => p.id);

    // Memoize this to prevent the Table from thinking the selection changed 
    // every time the parent re-renders.
    const selectedRowKeys = useMemo(() => platforms.map(f => f.id), [platforms]);
    const rowSelection = {
        preserveSelectedRowKeys: true, //  keep selected keys even if they are not in the current page
        selectedRowKeys,
        onChange: (newKeys: React.Key[]) => {
            const stringKeys = newKeys.map(String);

            // Identify added/removed by comparing newKeys vs current state
            const added = stringKeys.filter(key => !selectedRowKeys.includes(key));
            const removed = selectedRowKeys.filter(key => !stringKeys.includes(key));

            if (added.length > 0) addPlatforms(added);
            if (removed.length > 0) removePlatforms(removed);
        },

        selections: true
    };

    const columns = [
        // {
        //     title: "Platform id",
        //     dataIndex: "platform_id"
        // },
        {
            title: t("managehoops.tabs.machines.table.platform.columns.name"),
            dataIndex: "name"
        },
        {
            title: t("managehoops.tabs.machines.table.platform.columns.sf_area"),
            render: (_: any, record: ControlcenterMelcoControlCenterModelsPlatform) => {
                const selectedPlatform = platforms.find(
                    f => f.id === record.platform_id
                );

                return (
                    <Input
                        type="number"
                        value={selectedPlatform?.sf_area ?? ""}
                        onChange={(e) => {
                            if (!record.platform_id) return;
                            updateSfArea(record.platform_id, Number(e.target.value));
                        }}
                    />
                );
            }
        }
    ];

    return (
        <Table
            rowKey="platform_id"
            dataSource={platformData}
            columns={columns}
            rowSelection={rowSelection}
            pagination={{ pageSize: 10 }}
        />
    );
};